import { useState, useEffect } from 'react';
import { fetchNovidades } from '../data/mockData';

export const useNovidades = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const result = await fetchNovidades();
        setData(result);
        
        console.log('Novidades carregadas:', result);
      } catch (err) {
        setError(err);
        console.error('Erro ao carregar novidades:', err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return { data, error, loading };
};
